import { RouteObject } from 'react-router-dom';
import ErrorPage, { Page404 } from 'src/error-page';
import { DEFAULT_PUBLIC_PERSON_SIMULATOR_MKT_PATH, DEFAULT_PUBLIC_PERSON_SIMULATOR_PATH } from './constants';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

// `constants.ts` se importa de forma normal a proposito: son las dos cadenas con las que se
// construyen los `path`, y esos hacen falta antes de que el router decida nada.
const PublicPersonSimulatorView = lazyConReintento(() => import('./index'));

const paths = [`${DEFAULT_PUBLIC_PERSON_SIMULATOR_PATH}/:accessId?`, '/simulador-personas/:accessId?', '/public-person-simulator/:accessId?'];
const mktPaths = [`${DEFAULT_PUBLIC_PERSON_SIMULATOR_MKT_PATH}/:accessId?`];

const publicPersonSimulatorRoutes: RouteObject[] = [
  ...paths.map((path) => ({
    path,
    element: diferida(<PublicPersonSimulatorView isMkt={false} />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: diferida(<PublicPersonSimulatorView isMkt={false} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  })),
  ...mktPaths.map((path) => ({
    path,
    element: diferida(<PublicPersonSimulatorView isMkt={true} />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: diferida(<PublicPersonSimulatorView isMkt={true} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  }))
];

export default publicPersonSimulatorRoutes;
